export default __webpack_public_path__ + "static/media/skill-how-to-lemonade.eafd8edb.svg";